<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="dateFrom">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="dateTo">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'name'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'userName'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-single-select-search-control>
                    <wbo-select-options>
                        <wbo-select-option value="Pending"
                                           label="wbo.stock-take.option.status.pending"></wbo-select-option>
                        <wbo-select-option value="Complete"
                                           label="wbo.stock-take.option.status.complete"></wbo-select-option>
                        <wbo-select-option value="Processing"
                                           label="wbo.stock-take.option.status.processing"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-column field="name"></wbo-column>
        <wbo-date-column field="stockTakeDate"></wbo-date-column>
        <wbo-column field="userName"></wbo-column>
        <wbo-column field="status"></wbo-column>
        <wbo-actions-search-column>
            <wbo-report-search-action [idColumn]="'stockTakeId'" [reportComponent]="StockTakeReportComponent"></wbo-report-search-action>
            <wbo-stock-take-export-search-action></wbo-stock-take-export-search-action>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
